<div class="modal-body">
  <div class="row">
    <video #tsoVideo class="rounded" width="100%" height="630" controls>
      <source
        src="https://s3.amazonaws.com/tsolife.com/Video+CTA+.mp4"
        type="video/mp4" />
      The browser does not support HTML5 videos.
    </video>
  </div>
</div>
